import React from 'react';
import { Grid, Switch } from '@material-ui/core';
import { CompanySettingkey } from 'utils/enum/CompanySettingEnum';
import useNotificationSettings from './useNotificationSettings';

const NotificationSettings = () => {
    const {
        classes,
        isPNM,
        disabledSwitch,
        autoPaymentValue,
        electronicPaymentValue,
        hasProvider,
        toggleAllowVehiclesAvailableLots,
    } = useNotificationSettings();

    return (
        <>
            <Grid container className={classes.box}>
                <p className={classes.title}>Electronic Payment</p>

                {hasProvider ? (
                    <>
                        {!isPNM && (
                            <Grid className={classes.toggle} item xs={12}>
                                <div className={classes.switchTitle}>
                                    Send Email Receipts for Auto Payments
                                </div>
                                <div className={classes.switchSubTitle}>
                                    Enable or disable automatic email receipts when an Auto
                                    payment is received.
                                </div>
                                <div />
                                <div>
                                    <Switch
                                        checked={autoPaymentValue}
                                        onChange={(value) => toggleAllowVehiclesAvailableLots(
                                            value,
                                            CompanySettingkey.SEND_EMAIL_RECEIPTS_FOR_AUTO_PAYMENTS,
                                        )}
                                        disabled={disabledSwitch}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </div>
                            </Grid>
                        )}
                        <Grid className={classes.toggle} item xs={12}>
                            <div className={classes.switchTitle}>
                                Send Email Receipts for External Electronic Payments
                            </div>
                            <div className={classes.switchSubTitle}>
                                Enable or disable automatic email receipts when payments are
                                received through external sources such as the provider’s payment
                                portal, kiosks, or other third-party channels.
                            </div>
                            <div>
                                <Switch
                                    checked={electronicPaymentValue}
                                    onChange={(value) => toggleAllowVehiclesAvailableLots(
                                        value,
                                        CompanySettingkey.SEND_EMAIL_RECEIPTS_FOR_EXTERNAL_ELECTRONIC_PAYMENTS,
                                    )}
                                    disabled={disabledSwitch}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </div>
                        </Grid>
                    </>
                )
                    : <p>No electronic payment providers are configured for this company.</p>}
            </Grid>
        </>
    );
};

export default NotificationSettings;
